/**
 * This file is auto-generated from formInputValueSnippet.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */
export const bloodPressure = (lang, params) => {
    switch (lang) {
        case 'en':
            return ['Blood pressure: ', params.value];
        case 'pl':
            return ['Ciśnienie krwi: ', params.value];
    }
};
export const birthDate = (lang, params) => {
    switch (lang) {
        case 'en':
            return ['Birth date: ', params.value];
        case 'pl':
            return ['Data urodzenia: ', params.value];
    }
};
export const gender = (lang, params) => {
    switch (lang) {
        case 'en':
            return ['Gender: ', params.value];
        case 'pl':
            return ['Płeć: ', params.value];
    }
};
export const measurement = (lang, params) => {
    switch (lang) {
        case 'en':
            return [params.label, ': ', params.value];
        case 'pl':
            return [params.label, ': ', params.value];
    }
};
//# sourceMappingURL=formInputValueSnippet.loc.js.map